<template>

    <section id="my-bookings">
        <div class="booking-grid">
            <h1>Mine Reservationer</h1>
            <ul class="gridlist">
                <li v-for="b in bookings" class="card" :key="b.pk">
                    <booking :data="b" />
                </li>            
            </ul>
            <p v-if="!bookings || bookings.length < 1">
                Du har ikke nogen reservationer.
            </p>
        </div>
    </section>

</template>

<script>

    import axios from '../../utils/Http.js'
    import booking from '../booking/BookingMini.vue'
    import { dateJs2django, displayJSDate } from '../../utils/Filters.js'
    
    export default {

        components: {
            booking
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            bookings: function() {
                return this.$store.getters.getUserBookingList
            }
        },
        created: function() {
            this.$store.dispatch('fetchUserBookings')
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #my-bookings {
        padding: 1rem;
    }

    @media screen and (min-width: $wide) {

        #my-bookings {
            display: flex;
            flex-flow: row nowrap;

            .booking-grid {
                width: calc(100vw - 2rem);
            }
            .booking-filter {
                order: 1;
                margin-right: 2rem;
            }
            .booking-grid {
                order: 2;
            }

        }

    }

</style>
